import { createSlice } from "@reduxjs/toolkit";
import { getItemFromLocalStorage } from "../../helpers/utils";

const initialState = {
  user: getItemFromLocalStorage("user") || {},
  isLoggedIn: getItemFromLocalStorage("isLoggedIn") || false,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    loginSuccess(state, action) {
      state.user = action.payload;
    },
  },
});

export const { loginSuccess } = loginSlice.actions;
export default loginSlice.reducer;
